<script>
import * as m from '@app/paraglide/messages.js';
import { environment } from "@app/store/envStore.svelte.js";
import { slide } from 'svelte/transition';

// State for dismissing the banner
let dismissed = $state(false);
let dontShowAgain = $state(false);

// Check localStorage for persistent dismissal
if (typeof localStorage !== 'undefined') {
    dismissed = localStorage.getItem('desktopBannerDismissed') === 'true';
}

function dismissBanner() {
    dismissed = true;
    if (dontShowAgain && typeof localStorage !== 'undefined') {
        localStorage.setItem('desktopBannerDismissed', 'true');
    }
}

// Only show if online AND browser (web version), not iframe, and not dismissed
let shouldShow = $derived(environment.online && environment.browser && !environment.iframe && !dismissed);
</script>

{#if shouldShow}
    <div class="desktop-banner shadow" transition:slide={{ duration: 300 }}>
        <div class="container-fluid">
            <div class="d-flex align-items-center justify-content-between py-2 flex-wrap gap-3">
                <div class="spacer"></div>
                <div class="d-flex align-items-center gap-3 flex-wrap justify-content-center">
                    <div class="d-flex align-items-center gap-2">
                        <i class="bi bi-download fs-5"></i>
                        <span class="banner-text">
                            {m.desktop_banner_message()}
                        </span>
                    </div>
                    <a 
                        href="https://www.closedcaptioncreator.com/downloads.html" 
                        target="_blank"
                        class="btn btn-sm btn-primary fw-bold">
                        {m.desktop_banner_download_button()}
                    </a>
                </div>
                <div class="d-flex align-items-center gap-2">
                    <div class="form-check">
                        <input 
                            class="form-check-input" 
                            type="checkbox" 
                            id="dontShowAgainCheck"
                            bind:checked={dontShowAgain}>
                        <label class="form-check-label small" for="dontShowAgainCheck">
                            {m.desktop_banner_dont_show_again()}
                        </label>
                    </div>
                    <button 
                        id="desktopBannerCloseButton"
                        type="button"
                        class="btn-close btn-close-white"
                        aria-label={m.desktop_banner_close_aria_label()}
                        onclick={dismissBanner}></button>
                </div>
            </div>
        </div>
    </div>
{/if}